import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { DadosPaginacao } from './dadosPaginacao';
import { Observable } from 'rxjs/Observable';
import { ConfiguracaoPaginacao } from './configuracaoPaginacao';

@Component({
  selector: 'app-paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.scss']
})
export class PaginacaoComponent implements OnInit {

  @ViewChild('paginacao') paginacao: MatPaginator;
  totalPaginas: number;
  tamanhoPagina = 10;
  indicePagina = 0;

  /**
   * Lancador de eventos quando a paginacao sofre alguma alteracao
   */
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onPaginationChange: EventEmitter<DadosPaginacao> = new EventEmitter();

  /**
   * Indicador para avisar que a paginação deve ser reiniciada
   */
  @Input() indicadorReinicializacao: Observable<ConfiguracaoPaginacao>;

  constructor() { }

  ngOnInit() {

    this.indicadorReinicializacao.subscribe((configuracaoPaginacao) => {
      if (!configuracaoPaginacao) {
        return;
      }

      this.totalPaginas = configuracaoPaginacao.totalPaginas;
      this.indicePagina = configuracaoPaginacao.paginaAtual;
      this.paginacao.firstPage();
    });

    // inicializando paginacao
    const pageEvent = new PageEvent();
    pageEvent.pageIndex = this.indicePagina;
    pageEvent.pageSize = this.tamanhoPagina;
    this.onPagination(pageEvent);
  }

  onPagination(evt: PageEvent) {
    this.tamanhoPagina = evt.pageSize;
    this.indicePagina = evt.pageIndex;

    const dadosPaginacao = new DadosPaginacao(this.tamanhoPagina, this.indicePagina);

    this.onPaginationChange.emit(dadosPaginacao);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/paginacao/paginacao.component.ts